import {ContentState} from '../../store';
import {MESSAGE_MODE} from '../constants';

export const initialSlackContentState: ContentState = {
  init: false,
  form: {
    editor_mode: MESSAGE_MODE.WYSIWYG,
    channels: null,
    integration_id: '',
    value_markdown: '',
    value_html: '',
    value_json: '',
    thread_ts: '',
    attachments_to_thread: false,
    attachments: [],
    send_with_all_attachments: true,
    merge_pdf_config: {},
    merge_csv_config: {},
  },
  isPreview: false,
  tmpForm: {},
}
